import { IParams } from '../..';

// https://cianru.atlassian.net/wiki/spaces/audience/pages/1195802656/desktop
export const RENT_URBAN_ORDER: (keyof IParams)[] = [
  'undergroundTime', // До метро
  'facilities', // Удобства
  'area', // Площадь, кв.м
  'roomsTotal', // Комнат в квартире
  'roomsInDeal', // Комнат в аренду/Комнат на продажу
  'layout', // Планировка
  'dwellingStatus', // Апартаменты
  'floor', // Этаж
  'floorsTotal', // Этажей в доме
  'repair', // Ремонт
  'bathType', // Ванна/душ
  'bathrooms', // Санузел
  'ceilingHeight', // Высота потолков
  'houseYear', // Год постройки
  'houseMaterial', // Материал дома
  'windows', // Вид из окна
  'elevators', // Лифт
  'parking', // Парковка
  'rentTime', // Срок аренды
  'tenants', // Состав съемщиков
  'demolishedInMoscowProgramm', // Дома под снос
  'livingTerms', // Условия проживания
  'rentTerms', // Условия сделки
  'publish', // Дата публикации
  'wordsInclude', // Содержит слова в объявлении
  'wordsExclude', // Исключить объявления со словами
  'phone', // Поиск по номеру телефона
  'offerId', // Поиск по номеру объявления
];
